import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import logo from "../../Components/Navbar/assets/logo.svg";
import { getKeycloakPasswordResetUrl } from "../../config/keycloak";

export const SendPasswordRecoveryEmail: React.FC = () => {
  useEffect(() => {
    const redirectUri = `${window.location.origin}/login`;
    const forgotPasswordUrl = getKeycloakPasswordResetUrl(redirectUri);

    // Redirect to Keycloak password reset page
    window.location.href = forgotPasswordUrl;
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fdfdfd",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <img
        src={logo}
        alt="logo"
        style={{ width: "250px", height: "auto" }}
      />
      <CircularProgress size={50} />
      <Typography variant="h6" color="text.secondary">
        Redirecionando para recuperação de senha...
      </Typography>
    </Box>
  );
};
